<template>
  <div>
    <v-flex>
      <v-select
        class="small-text-field"
        :error-messages="errorMessages"
        :required="required"
        :value="taxiType"
        :items="bodyTypes"
        :v-model="taxiType"
        :label="label"
        item-value="type"
        item-name="name"
        @input="updateSelf"
        hide-details
        :height="28"
        clearable
        outlined
        dense
        :placeholder="placeholder"
        style="width: 90px;"
      >
        <template v-slot:selection="{ item, index }">
          <span style="font-size: 12px !important">{{item.name}}</span>
        </template>
        <template v-slot:item="{ item, index }">
          <span style="font-size: 12px !important">{{item.name}}</span>
        </template>
      </v-select>
    </v-flex>
    <v-dialog
      v-model="showLuggageInfoDialog"
      width="1000"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Luggage Information
        </v-card-title>
        <v-card-text>
          <LuggageInfoBox></LuggageInfoBox>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="showLuggageInfoDialog = false"
          >
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { BookingForm } from "@/components/util/BookingForm.js";
import LuggageInfoBox from '@/components/luggage/LuggageInfoBox'

export default {
  name: "SelectableBodyStyleInput",
  components: {LuggageInfoBox},
  model: {
    prop: "taxiType",
    event: "input"
  },
  props: {
    placeholder: String,
    label: String,
    errorMessages: Object,
    required: { type: Boolean, default: true },
    taxiType: String
  },
  data() {
    return {
      showLuggageInfoDialog: false,
      menu: false,
      bodyTypes: BookingForm.VEHICLE_TYPES()
    };
  },
  methods: {
    updateSelf(rideType) {
      this.$emit("input", rideType);
    },
    focused() {
      console.log("focused");
      this.$emit("focused");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
